import React, { useEffect, useRef } from 'react';
import { useStoreConfigContext } from '/src/providers';
import { H2 } from '/src/components';
import * as styles from './styles.scss';

const TrustPilot = () => {
    const { translate, storeConfig: { locale } } = useStoreConfigContext();
    const ref = useRef(null);

    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <>
            <H2 className={styles.name}>{translate('Customer reviews')}</H2>
            <div className={styles.trust}>
                <div
                    ref={ref}
                    className="trustpilot-widget"
                    data-locale={locale.replace('_', '-')}
                    data-template-id="53aa8912dec7e10d38f59f36"
                    data-businessunit-id="4be601cf0000640005096397"
                    data-style-height="140px"
                    data-style-width="100%"
                    data-theme="light"
                    data-review-languages="en"
                />
            </div>
        </>
    )
};

export default TrustPilot;
